//export default 'https://sleep-well.coach'
//export default 'http://localhost:3002';
export default process.env.VUE_APP_QUIZ_URL;
